import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;

    setStatus('loading');
    try {
      const formData = new URLSearchParams();
      formData.append('email', email.trim());

      const res = await fetch('https://readdy.ai/api/form/d6672ts2hrrhr32veqsg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Newsletter subscription failed:', error);
      setStatus('error');
    } finally {
      setTimeout(() => setStatus('idle'), 4000);
    }
  };

  return (
    <footer className="bg-[#1B4332] text-white py-12">
      <div className="max-w-[1060px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Stelvar Holdings</h3>
            <p className="text-white/80 text-sm leading-relaxed mb-3">
              Strategic Consulting &amp; Digital Systems
            </p>
            <p className="text-white/70 text-xs leading-relaxed">
              Founded by Giedrius Petrauskas
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer">
                  Terms of Use
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Newsletter</h3>
            <p className="text-white/80 text-sm mb-3">Stay updated with ideas about strategy,systems and solving complex problems.</p>
            <form
              id="newsletter-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="flex flex-col gap-2"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                required
                className="w-full px-3 py-2 rounded-md bg-white/10 border border-white/20 text-white placeholder-white/50 text-sm focus:outline-none focus:border-white/50 transition-colors"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="whitespace-nowrap px-4 py-2 bg-white text-[#1B4332] rounded-md text-sm font-medium hover:bg-white/90 transition-colors cursor-pointer disabled:opacity-60"
              >
                {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>
            {status === 'success' && (
              <p className="text-emerald-300 text-xs mt-2">Thanks for subscribing!</p>
            )}
            {status === 'error' && (
              <p className="text-red-300 text-xs mt-2">Something went wrong. Try again.</p>
            )}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/70 text-sm">
            &copy; 2025 Giedrius Petrauskas. All rights reserved.
          </p>
          <a
            href="https://www.linkedin.com/in/giedriuspetrauskas/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center gap-2 text-white/70 hover:text-white transition-colors duration-300 text-sm cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-linkedin-box-fill text-lg" />
            </div>
            <span>LinkedIn</span>
          </a>
        </div>
      </div>
    </footer>
  );
}